<tg-row class="summary-page-rental-details-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Sale information</p>
    </tg-col>
    <tg-col
        md="6"
        sm="12"
        class="summary-page-rental-details-section__header--right"
    >
        <a
            routerLink="../{{ stepIds.propertyInformation }}"
            routerLinkActive="active"
            class="h-link-no-visited"
            >Edit sale information</a
        >
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Sale type:</span
        >
        {{ saleType }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Expected sale price:</span
        >
        {{ expectedSalePrice }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >Capital value:</span
        >
        {{ rateableValue }}
    </tg-col>
</tg-row>
<tg-row>
    <tg-col class="summary-page-rental-details-section__content">
        <span class="summary-page-rental-details-section__content-label"
            >End date:</span
        >
        {{ endDate }}
    </tg-col>
</tg-row>
